import { FC, ReactNode } from "react";

const CustomLabel: FC<CustomLabelProps> = ({
  isRequired,
  htmlFor,
  labelText,
  labelWrapClass,
  labelTextClass,
  childrenClass,
  children,
}) => {
  return (
    <label
      htmlFor={htmlFor}
      className={`flex flex-col gap-3 w-full ${labelWrapClass}`}
    >
      <div
        className={`flex items-center gap-1 font-[800] text-base leading-[20px] text-black ${labelTextClass}`}
      >
        {labelText}
        {isRequired && (
          <span className="text-danger font-[600] text-base leading-5">*</span>
        )}
      </div>

      {children && <div className={childrenClass}>{children}</div>}
    </label>
  );
};

export default CustomLabel;

interface CustomLabelProps {
  isRequired?: boolean;
  labelText?: string;
  htmlFor?: string;
  labelWrapClass?: string;
  labelTextClass?: string;
  childrenClass?: string;
  children?: ReactNode;
}
